module.exports = __webpack_public_path__ + "img/beian.a5e41ece.png";